import moment from 'moment';

export default function BusinessDays() {
  let dates = []
  let counter = 0;
  var currentDay = moment();
  while (dates.length < 10) {
    if ([0, 6].includes(currentDay.weekday()) === false) {
      let date = { label: currentDay.format('dddd, MMMM D'), value: currentDay.format('MM-DD-YYYY') };
      if (counter < 3) {
        date.disabled = true;
      } 
      dates.push(date);
      counter++;
    }
    currentDay.add(1, 'day');
  }
  return dates;
}




// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/BusinessDays.js